import {backendRequest} from "../utils/backend";
import {FETCH_ALL_ITEMS} from "../config";

export const getQualities = () => {
    return backendRequest.get(`/quality?page=1&size=${FETCH_ALL_ITEMS}`)
};

export const createQuality = (quality) => {
    return backendRequest.post(`/quality`, {"name": quality})
 };